import React, { useState } from 'react';
import { SectionHeader } from '../components/shared/SectionHeader';
import { ServiceCard } from '../components/shared/ServiceCard';
import { ServiceModal } from '../components/services/ServiceModal';
import { Building2, Hammer, PenTool, Wrench, ClipboardList, Home, Package, Shield, Settings } from 'lucide-react';
export function ServicesPage() {
  const [selectedService, setSelectedService] = useState<any>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const services = [{
    icon: <Building2 size={40} data-id="element-508" />,
    title: 'Building Construction',
    description: 'Comprehensive construction services for residential, commercial, and institutional projects.',
    features: ['Residential developments', 'Commercial buildings', 'Public facilities', 'High-rise construction', 'Quality materials'],
    benefits: ['Timely delivery', 'Cost-effective', 'Building code compliance', 'Sustainable practices', 'Expert teams']
  }, {
    icon: <Hammer size={40} data-id="element-509" />,
    title: 'Civil Engineering Works',
    description: 'Expert civil engineering solutions including drainage, earthworks, and infrastructure.',
    features: ['Drainage systems', 'Earthworks', 'Retaining walls', 'Road construction', 'Site utilities'],
    benefits: ['Advanced engineering', 'Durable infrastructure', 'Environmental compliance', 'Efficient execution', 'Long-term reliability']
  }, {
    icon: <PenTool size={40} data-id="element-510" />,
    title: 'Design & Build Services',
    description: 'Integrated design and construction with 3D visualization and MEP engineering.',
    features: ['Architectural planning', '3D visualization', 'Structural engineering', 'MEP design', 'Interior design'],
    benefits: ['Single responsibility', 'Streamlined communication', 'Design optimization', 'Cost savings', 'Faster completion']
  }, {
    icon: <Wrench size={40} data-id="element-511" />,
    title: 'Renovation & Remodeling',
    description: 'Professional renovation services to transform existing spaces.',
    features: ['Residential renovations', 'Commercial remodeling', 'Structural modifications', 'Interior upgrades', 'Facade improvements'],
    benefits: ['Enhanced value', 'Improved functionality', 'Modern aesthetics', 'Energy efficiency', 'Minimal disruption']
  }, {
    icon: <ClipboardList size={40} data-id="element-512" />,
    title: 'Project Management',
    description: 'Professional project management ensuring timely delivery and cost efficiency.',
    features: ['Project planning', 'Cost estimation', 'Quality control', 'Risk management', 'Stakeholder coordination'],
    benefits: ['Expert oversight', 'Reduced risks', 'Optimized resources', 'Transparent reporting', 'Successful outcomes']
  }, {
    icon: <Home size={40} data-id="element-513" />,
    title: 'Real Estate Development',
    description: 'End-to-end real estate development from acquisition to completion.',
    features: ['Land acquisition', 'Feasibility studies', 'Master planning', 'Property development', 'Sales support'],
    benefits: ['Comprehensive solutions', 'Market-driven designs', 'Investment optimization', 'Regulatory compliance', 'Proven track record']
  }, {
    icon: <Package size={40} data-id="element-514" />,
    title: 'Procurement & Logistics',
    description: 'Efficient procurement and logistics management for construction materials.',
    features: ['Material sourcing', 'Vendor management', 'Quality assurance', 'Logistics coordination', 'Inventory management'],
    benefits: ['Cost-effective procurement', 'Quality materials', 'Timely deliveries', 'Reduced delays', 'Transparent processes']
  }, {
    icon: <Shield size={40} data-id="element-515" />,
    title: 'HSE Management',
    description: 'Comprehensive Health, Safety, and Environment management.',
    features: ['Safety policy development', 'Risk assessments', 'PPE provision', 'Emergency planning', 'Regulatory compliance'],
    benefits: ['Zero-accident culture', 'Compliance', 'Worker protection', 'Reduced liability', 'Enhanced reputation']
  }, {
    icon: <Settings size={40} data-id="element-516" />,
    title: 'Facility Management',
    description: 'Professional facility management for optimal building performance.',
    features: ['Preventive maintenance', 'Building operations', 'Energy management', 'Security services', 'Cleaning services'],
    benefits: ['Extended asset life', 'Reduced costs', 'Improved efficiency', 'Tenant satisfaction', 'Comprehensive support']
  }];
  const handleServiceClick = (service: any) => {
    setSelectedService(service);
    setModalOpen(true);
  };
  return <div className="min-h-screen pt-20" data-id="element-517">
      <SectionHeader title="Our Services" subtitle="Comprehensive construction and engineering solutions tailored to your needs" data-id="element-518" />

      <section className="py-20" data-id="element-519">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-520">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-521">
            {services.map((service, index) => <ServiceCard key={index} icon={service.icon} title={service.title} description={service.description} index={index} onClick={() => handleServiceClick(service)} data-id="element-522" />)}
          </div>
        </div>
      </section>

      {selectedService && <ServiceModal isOpen={modalOpen} onClose={() => setModalOpen(false)} service={selectedService} data-id="element-523" />}
    </div>;
}